export default "__VITE_ASSET__C6H0hDx9__"